import {
    useNavigate,
} from 'react-router-dom';
import styled from 'styled-components';
import {
    Card,
    Typography,
} from "@mui/material";

import { BillDetailsInterface } from '../../Models/Billing/Billing';

import DateHelper from '../../Utilities/Helpers/DateHelper';
import RequiredParametersHelper from '../../Utilities/Helpers/RequiredParametersHelper';

import { ViewType } from '../../Utilities/Enums/ViewTypeEnum';
import { RouteEnum } from '../../Utilities/Enums/RouteEnums';
import { DetailsInvoiceField, BillingDetailsField, BillingAddressField } from '../../Utilities/Enums/ParametersEnum';

import CompanyDropdown from '../../CustomViews/Elements/AutoComplete/CompanyDropdown';
import FormTextField from '../../CustomViews/Elements/FormTextField';
import FormDatePicker from '../../CustomViews/Elements/FormDatePicker';
import NewTab from '../../CustomViews/Pages/NewTab/NewTab';

const InvoiceDetailsContainer = styled(Card) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: none !important
    border-radius: 0px !important;
    box-shadow: none !important;
    width: 100%;
    display: flex;
    justify-content: space-between;

    .detailFieldsContainer {
        width: 30%;
        display: grid;
        grid-template-columns: auto 0.1fr 5fr;
        column-gap: 10px;
        row-gap: 5px;
        height: max-content;

        .detailFieldHeader,
        .colon {
            font-size: 0.825rem;
            font-weight: 500;
            color: #878a99;

            .requiredText {
                color: var(--textDangerColor);
            }
        }

        .detailFieldvalue {
            font-size: 0.825rem;
            font-weight: 500;
        }

        .customDatePicker {
            width: -webkit-fill-available;

            .MuiStack-root {
                width: -webkit-fill-available;

                .MuiFormControl-root.MuiTextField-root,
                .MuiFormControl-root.MuiPickersTextField-root {
                    width: -webkit-fill-available !important;
                }
            }
        }
    }
`;

export default function BillDetails(props: BillDetailsInterface) {
    // Variables
    let {
        viewType,
        setviewType,
        formData,
        setformData,
        previewData,
        setpreviewData,
        errorMessages,
        setErrorMessages,
        isPrint,
    } = props;
    let navigate = useNavigate();
    let requiredFields = RequiredParametersHelper.billings();

    // Use States

    //Variables
    const issuedCompanyProps = {
        name: BillingDetailsField.COMPANY_PUBLIC_ID,
        title: 'Issued Company',
        fieldValue: formData?.[DetailsInvoiceField.COMPANY_PUBLIC_ID] ?? "",
        required: requiredFields?.find((field: any) => field.keyName == DetailsInvoiceField.COMPANY_PUBLIC_ID)?.keyName != null,
        errorMessages: errorMessages,
        hideLabel: true,
        handleOnChange: (selectedValue: any) => {
            if(setformData) {
                setformData((prev: any) => ({
                    ...prev,
                    [DetailsInvoiceField.COMPANY_PUBLIC_ID]: selectedValue?.id ?? null,
                    [DetailsInvoiceField.BILLING_DETAILS]: {
                        ...formData?.[DetailsInvoiceField.BILLING_DETAILS],
                        [BillingDetailsField.COMPANY_PUBLIC_ID]: selectedValue?.id ?? null,
                        [BillingDetailsField.NAME]: selectedValue?.name ?? '',
                        [BillingDetailsField.CONTACT_PERSON]: selectedValue?.contactPerson ?? '',
                        [BillingDetailsField.CONTACT_PHONE]: selectedValue?.contactPhoneNo ?? '',
                        [BillingDetailsField.ADDRESS]: {
                            ...selectedValue?.[BillingDetailsField.ADDRESS],
                            [BillingAddressField.FULL_ADDRESS]: selectedValue?.fullAddress ?? '',
                        },
                    }
                }));
            }
        },
    },
        billingAddressProps = {
            name: BillingAddressField.FULL_ADDRESS,
            title: 'Billing Address',
            fieldValue: formData?.[DetailsInvoiceField.BILLING_DETAILS]?.[BillingDetailsField.ADDRESS]?.[BillingAddressField.FULL_ADDRESS] ?? "",
            type: 'text',
            required: requiredFields?.find((field: any) => field.keyName == DetailsInvoiceField.BILLING_DETAILS)?.fields?.find((f: any) => f.keyName == BillingDetailsField.ADDRESS)?.fields?.find((f: any) => f.keyName == BillingAddressField.FULL_ADDRESS)?.keyName != null,
            errorMessages: errorMessages,
            hideLabel: true,
            handleOnChange: (selectedValue: any) => {
                if(setformData) {
                    setformData((prev: any) => ({
                        ...prev,
                        [DetailsInvoiceField.BILLING_DETAILS]: {
                            ...formData?.[DetailsInvoiceField.BILLING_DETAILS],
                            [BillingDetailsField.ADDRESS]: {
                                ...formData?.[DetailsInvoiceField.BILLING_DETAILS]?.[BillingDetailsField.ADDRESS],
                                [BillingAddressField.FULL_ADDRESS]: selectedValue,
                            },
                        }
                    }));
                }
            },
        },
        contactNoProps = {
            name: BillingDetailsField.CONTACT_PHONE,
            title: 'Contact No.',
            fieldValue: formData?.[DetailsInvoiceField.BILLING_DETAILS]?.[BillingDetailsField.CONTACT_PHONE] ?? "",
            type: 'text',
            required: requiredFields?.find((field: any) => field.keyName == DetailsInvoiceField.BILLING_DETAILS)?.fields?.find((f: any) => f.keyName == BillingDetailsField.CONTACT_PHONE)?.keyName != null,
            errorMessages: errorMessages,
            hideLabel: true,
            handleOnChange: (selectedValue: any) => {
                if(setformData) {
                    setformData((prev: any) => ({
                        ...prev,
                        [DetailsInvoiceField.BILLING_DETAILS]: {
                            ...formData?.[DetailsInvoiceField.BILLING_DETAILS],
                            [BillingDetailsField.CONTACT_PHONE]: selectedValue,
                        }
                    }));
                }
            },
        },
        contactPersonProps = {
            name: BillingDetailsField.CONTACT_PERSON,
            title: 'Contact Person',
            fieldValue: formData?.[DetailsInvoiceField.BILLING_DETAILS]?.[BillingDetailsField.CONTACT_PERSON] ?? "",
            type: 'text',
            required: requiredFields?.find((field: any) => field.keyName == DetailsInvoiceField.BILLING_DETAILS)?.fields?.find((f: any) => f.keyName == BillingDetailsField.CONTACT_PERSON)?.keyName != null,
            errorMessages: errorMessages,
            hideLabel: true,
            handleOnChange: (selectedValue: any) => {
                if(setformData) {
                    setformData((prev: any) => ({
                        ...prev,
                        [DetailsInvoiceField.BILLING_DETAILS]: {
                            ...formData?.[DetailsInvoiceField.BILLING_DETAILS],
                            [BillingDetailsField.CONTACT_PERSON]: selectedValue,
                        }
                    }));
                }
            },
        },
        billingDateProps = {
            name: DetailsInvoiceField.INVOICE_DATE,
            title: 'Billing Date',
            fieldValue: formData?.[DetailsInvoiceField.INVOICE_DATE] ?? null,
            required: requiredFields?.find((field: any) => field.keyName == DetailsInvoiceField.INVOICE_DATE)?.keyName != null,
            errorMessages: errorMessages,
            hideLabel: true,
            handleOnChange: (selectedValue: any) => {
                if(setformData) {
                    setformData((prev: any) => ({
                        ...prev,
                        [DetailsInvoiceField.INVOICE_DATE]: selectedValue ?? null,
                    }));
                }
            },
        },
        invoiceNoProps = {
            name: DetailsInvoiceField.TRANS_NO,
            title: 'Invoice No',
            fieldValue: formData?.[DetailsInvoiceField.TRANS_NO] ?? "",
            type: 'text',
            required: requiredFields?.find((field: any) => field.keyName == DetailsInvoiceField.TRANS_NO)?.keyName != null,
            errorMessages: errorMessages,
            hideLabel: true,
            disabled: true,
            handleOnChange: (selectedValue: any) => {
                if(setformData) {
                    setformData((prev: any) => ({
                        ...prev,
                        [DetailsInvoiceField.TRANS_NO]: selectedValue,
                    }));
                }
            },
        },
        generatedLicenseKeyProps = {
            name: DetailsInvoiceField.GENERATED_LICENSE_KEY,
            title: 'Generated License Key',
            fieldValue: formData?.[DetailsInvoiceField.GENERATED_LICENSE_KEY] ?? "",
            type: 'text',
            required: requiredFields?.find((field: any) => field.keyName == DetailsInvoiceField.GENERATED_LICENSE_KEY)?.keyName != null,
            errorMessages: errorMessages,
            hideLabel: true,
            disabled: true,
            handleOnChange: (selectedValue: any) => {
                if(setformData) {
                    setformData((prev: any) => ({
                        ...prev,
                        [DetailsInvoiceField.GENERATED_LICENSE_KEY]: selectedValue,
                    }));
                }
            },
        };

    //Event Handlers
    
    //Rendering Functions
    const renderFieldheader = (title: any = null, required: boolean = false) => {
        return <Typography className="detailFieldHeader">{title ?? "--"} <span className="requiredText">{required && "*"}</span></Typography>
    }

    return <InvoiceDetailsContainer className="invoiceDetailsContainer bDetails">
        <div className="detailFieldsContainer">
            {!isPrint && renderFieldheader(issuedCompanyProps?.title ?? "--", issuedCompanyProps?.required)}
            {!isPrint && <Typography className="colon">:</Typography>}
            {viewType != ViewType.PREVIEW && <CompanyDropdown {...issuedCompanyProps} />}
            {(viewType == ViewType.PREVIEW && (previewData?.[DetailsInvoiceField.COMPANY_PUBLIC_ID] ?
                <NewTab
                linkClassName={"detailFieldvalue"}
                linkTitle={previewData?.[DetailsInvoiceField.BILLING_DETAILS]?.[BillingDetailsField.NAME] != null && previewData?.[DetailsInvoiceField.BILLING_DETAILS]?.[BillingDetailsField.NAME] != "" ? previewData?.[DetailsInvoiceField.BILLING_DETAILS]?.[BillingDetailsField.NAME] : "--"}
                linkUrl={`${RouteEnum.COMPANY_DETAILS}?id=${previewData?.[DetailsInvoiceField.COMPANY_PUBLIC_ID]}&view=${ViewType.PREVIEW}`} /> : <Typography className="detailFieldvalue">--</Typography>
            ))}

            {!isPrint && renderFieldheader(billingAddressProps?.title ?? "--", billingAddressProps?.required)}
            {!isPrint && <Typography className="colon">:</Typography>}
            {viewType != ViewType.PREVIEW && <FormTextField {...billingAddressProps} />}
            {viewType == ViewType.PREVIEW && <Typography className={"detailFieldvalue " + (isPrint ? "span3Item" : "")}>{previewData?.[DetailsInvoiceField.BILLING_DETAILS]?.[BillingDetailsField.ADDRESS]?.[BillingAddressField.FULL_ADDRESS] != null && previewData?.[DetailsInvoiceField.BILLING_DETAILS]?.[BillingDetailsField.ADDRESS]?.[BillingAddressField.FULL_ADDRESS] != "" ? previewData?.[DetailsInvoiceField.BILLING_DETAILS]?.[BillingDetailsField.ADDRESS]?.[BillingAddressField.FULL_ADDRESS] : "--"}</Typography>}

            {renderFieldheader((!isPrint ? (contactNoProps?.title ?? "--") : "Tel"), contactNoProps?.required)}
            <Typography className="colon">:</Typography>
            {viewType != ViewType.PREVIEW && <FormTextField {...contactNoProps} />}
            {viewType == ViewType.PREVIEW && <Typography className="detailFieldvalue">{previewData?.[DetailsInvoiceField.BILLING_DETAILS]?.[BillingDetailsField.CONTACT_PHONE] != null && previewData?.[DetailsInvoiceField.BILLING_DETAILS]?.[BillingDetailsField.CONTACT_PHONE] != "" ? previewData?.[DetailsInvoiceField.BILLING_DETAILS]?.[BillingDetailsField.CONTACT_PHONE] : "--"}</Typography>}

            {renderFieldheader((!isPrint ? (contactPersonProps?.title ?? "--") : "Att"), contactPersonProps?.required)}
            <Typography className="colon">:</Typography>
            {viewType != ViewType.PREVIEW && <FormTextField {...contactPersonProps} />}
            {viewType == ViewType.PREVIEW && <Typography className="detailFieldvalue">{previewData?.[DetailsInvoiceField.BILLING_DETAILS]?.[BillingDetailsField.CONTACT_PERSON] != null && previewData?.[DetailsInvoiceField.BILLING_DETAILS]?.[BillingDetailsField.CONTACT_PERSON] != "" ? previewData?.[DetailsInvoiceField.BILLING_DETAILS]?.[BillingDetailsField.CONTACT_PERSON] : "--"}</Typography>}
        </div>

        <div className="detailFieldsContainer">
            {renderFieldheader((!isPrint ? (billingDateProps?.title ?? "--") : "Date"), billingDateProps?.required)}
            <Typography className="colon">:</Typography>
            {viewType != ViewType.PREVIEW && <FormDatePicker {...billingDateProps} />}
            {viewType == ViewType.PREVIEW && <Typography className="detailFieldvalue">{previewData?.[DetailsInvoiceField.INVOICE_DATE] != null && previewData?.[DetailsInvoiceField.INVOICE_DATE] != "" ? DateHelper.getFormattedDate(previewData?.[DetailsInvoiceField.INVOICE_DATE], "dd/MM/yyyy") :  "--"}</Typography>}

            {renderFieldheader(invoiceNoProps?.title ?? "--", invoiceNoProps?.required)}
            <Typography className="colon">:</Typography>
            {viewType != ViewType.PREVIEW && <FormTextField {...invoiceNoProps} />}
            {viewType == ViewType.PREVIEW && <Typography className="detailFieldvalue">{previewData?.[DetailsInvoiceField.TRANS_NO] != null && previewData?.[DetailsInvoiceField.TRANS_NO] != "" ? previewData?.[DetailsInvoiceField.TRANS_NO] :  "--"}</Typography>}

            {renderFieldheader(generatedLicenseKeyProps?.title ?? "--", generatedLicenseKeyProps?.required)}
            <Typography className="colon">:</Typography>
            {viewType != ViewType.PREVIEW && <FormTextField {...generatedLicenseKeyProps} />}
            {viewType == ViewType.PREVIEW && <Typography className="detailFieldvalue">{previewData?.[DetailsInvoiceField.GENERATED_LICENSE_KEY] != null && previewData?.[DetailsInvoiceField.GENERATED_LICENSE_KEY] != "" ? previewData?.[DetailsInvoiceField.GENERATED_LICENSE_KEY] :  "--"}</Typography>}
        </div>
    </InvoiceDetailsContainer>
}
